export const initMedicineTemplateState = () => {
  return {
    id: "",
    date: "",
    templateName: "",
    initialTemplateName: "",
    drugType: "Tablet",
    drugName: "",
    strength: "0",
    freqMorn: 0,
    freqAfter: 0,
    freqNight: 0,
    frequencyPerWeek: "Everyday",
    duration: 0,
    durationUnit: "null",
    instruction: "",
    beforeFood: "",
    strengthUnit: "NA",
    composition: "",
  };
};

export const medicineMeasurements = [
  "million spores",
  "Mg SR",
  "Mg",
  "Mcg",
  "Gm",
  "Units",
  "%",
  "% w/v",
  "% w/w",
  "NA",
  "IU",
  "ml",
  "Cc",
];

export const medicineType = [
  "Capsule",
  "Cream",
  "Drops",
  "Foam",
  "Gel",
  "Inhaler",
  "Injection",
  "Lotion",
  "Mouthwash",
  "Ointment",
  "Powder",
  "Shampoo",
  "Spray",
  "Syringe",
  "Syrup",
  "Tablet",
  "Toothpaste",
  "Custom",
  "Gargle",
  "Suspension",
  "Gelly",
  "Liniment",
];

export const instructionDropdownOptions = [
  { text: "Null", value: "" },
  { text: "After food", value: "After food" },
  { text: "Before food", value: "Before food" },
  { text: "With food", value: "With food" },
  { text: "Bedtime", value: "Bedtime" },
  { text: "Empty Stomach", value: "Empty Stomach" },
];

export const parseMedicineInstructionField = (instruction) => {
  const predefinedOptions = instructionDropdownOptions.map((option) => ({
    instructionOptionProcessed: `(${option.value})`,
    instructionOptionValue: option.value,
  }));

  const foundOption = predefinedOptions.find((option) =>
    instruction?.includes(option?.instructionOptionProcessed)
  );
  const restInstruction = foundOption
    ? instruction.replace(foundOption?.instructionOptionProcessed, "").trim()
    : instruction;
  return {
    instructionDropdownOption:
      foundOption?.instructionOptionValue ||
      instructionDropdownOptions[0].value,
    instructionText: restInstruction,
  };
};

export const parseBeforeFoodDropdownValueFromMedDb = (beforeFoodValue) => {
  if (!beforeFoodValue) return instructionDropdownOptions[0].value;

  if (beforeFoodValue === "Yes" || beforeFoodValue === true)
    return instructionDropdownOptions[2].value; //before food

  return beforeFoodValue;
};

export const processMedicineInstructionField = (
  instructionDropdownValue,
  instructionText
) => {
  return instructionDropdownValue
    ? `${instructionText?.trim()} (${instructionDropdownValue})`
    : instructionText?.trim();
};

export const onChange = (state, key, value) => {
  return {
    ...state,
    [key]: value,
  };
};

export const getFormattedMedicineTemplate = (medicine) => {
  console.log(medicine);
  return {
    drugName: medicine.drugName,
    strength: medicine.strength.replace(/[^0-9./]/g, ""),
    strengthUnit: medicine.strength.replace(/[0-9./\s]/g, ""),
    freqMorn: medicine.frequency?.[0] || 0,
    freqAfter: medicine.frequency?.[1] || 0,
    freqNight: medicine.frequency?.[2] || 0,
    freqEvening: medicine.frequency?.[3] || 0,
    frequencyPerWeek: medicine.frequencyPerWeek,
    duration: Number(medicine.duration.replace(/[^0-9]/g, "")),
    durationUnit: medicine.duration.replace(/[0-9]/g, ""),
    instruction: medicine.instruction,
    drugType: medicine.drugType,
    composition: medicine?.composition || "",
  };
};
export const getMedicineInfo = (item) => {
  console.log(item);
  return {
    drugName: item.drugName,
    strength: item.strength.replace(/[^0-9./]/g, ""),
    strengthUnit: item.strength.replace(/[0-9./\s]/g, ""),
    freqMorn: item.frequency?.[0] || 0,
    freqAfter: item.frequency?.[1] || 0,
    freqNight: item.frequency?.[2] || 0,
    freqEvening: item.frequency?.[3] || 0,
    frequencyPerWeek: item.frequencyPerWeek,
    duration: item?.duration && Number(item?.duration?.replace(/[^0-9]/g, "")),
    durationUnit: item?.duration?.replace(/[0-9]/g, ""),
    instruction: parseMedicineInstructionField(item.instruction)
      .instructionText,
    beforeFood: parseMedicineInstructionField(item.instruction)
      .instructionDropdownOption,
    drugType: item.drugType,
    type: item.type,
    category: item.category,
    composition: item?.composition || "",
  };
};
